import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardApprovalService,
  RsuAwardApprovalService,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePsuAwardParticipantApprovalStatusOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const psuAwardParticipantApprovalStatus = useQuery(
    ['getPsuAwardParticipantApprovalStatus'],
    async () => {
      return await handleRequest(
        PsuAwardApprovalService.getApiAwardApiAppPSUAwardApprovalPSUAwardStatuses()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return psuAwardParticipantApprovalStatus;
};

export default usePsuAwardParticipantApprovalStatusOptions;
